export const scopeStringId = "product"